(function () {
	'use strict';

	angular.module('app.dashboard')
		.controller('unableToFixValueParetoCtrl', unableToFixValueParetoCtrl);

	function unableToFixValueParetoCtrl($scope, $rootScope, $translate, storeService, pastTimePeriodValue,
			leanFilterService, dashboardFilterInitializationService, $timeout, unableToFixValueParetoService,
			currencyFormatService) {
		$scope.isReadOnly = storeService.getState().reportSettings.readOnly;
		$scope.editingWidget = false;
		$scope.slideshowView = $rootScope.slideshowView;
		$scope.empty = true;
		$scope.filterService = dashboardFilterInitializationService;
		$scope.leanFilterService = leanFilterService;
		$scope.ignoreFilters = ['responsibleNdx', 'taskCategory', 'taskStatus'];
		$scope.totalUnableToFixDisplay = '$0';
		$scope.chartData = [];

		$scope.$parent.$parent.showViewReport = true;

		$scope.pastTimePeriods = [{
			'name': $translate.instant('All'),
			'value': 'all'
		}, {
			'name': $translate.instant('30 Days Back'),
			'value': '30'
		}, {
			'name': $translate.instant('90 Days Back'),
			'value': '90'
		}, {
			'name': $translate.instant('180 Days Back'),
			'value': '180'
		}, {
			'name': $translate.instant('1 Year Back'),
			'value': '365'
		}, {
			'name': $translate.instant('Previous Fiscal Year'),
			'value': 'previous'
		}, {
			'name': $translate.instant('Current Fiscal YTD'),
			'value': 'currentFiscalYTD'
		}];

		$scope.pastTimePeriod = _.find($scope.pastTimePeriods, { value: pastTimePeriodValue });

		$scope.getBarStyle = function (row) {
			return {
				width: row.barPercent + '%',
				backgroundColor: '#005DA7',
				height: '10px',
				display: 'inline-block',
				minWidth: row.unableToFixValue > 0 ? '2px' : '0'
			};
		};

		$scope.getLabel = function (row) {
			return row.displayName || row.unableToFixCategoryName || $translate.instant('No reason provided');
		};

		$scope.saveTimePeriod = function () {
			$scope.editingWidget = false;
			$scope.$parent.$parent.hidePencil = false;
			updateWidgetConfig();
			loadData();
		};

		function updateWidgetConfig() {
			var model = $scope.$parent.model;
			model.config.pastTimePeriod = $scope.pastTimePeriod ? $scope.pastTimePeriod.value : null;
			var columnDefinition = $scope.$parent.$parent.col;
			storeService.dispatch({
				type: storeService.actions.CONFIG_WIDGET_UPDATE_ONE,
				payload: {
					column: 'column' + columnDefinition.columnIndex,
					position: columnDefinition.widgets.indexOf(model),
					widget: {
						name: model.config.type,
						config: _.cloneDeep(model.config)
					}
				},
				meta: {
					reportName: undefined,
					reportSettingsId: globalReportName
				}
			});
		}

		$scope.$parent.$parent.editWidgetSettings = function () {
			$scope.editingWidget = true;
			$scope.$parent.$parent.hidePencil = true;
		};

		updateEventBind($scope, ['sideBarUpdate', 'adfFactoryChanged', 'slideshowViewChanged', 'inventoryFilterChanged']);

		function loadData() {
			if (!dashboardFilterInitializationService.updating['initialLoad']) {
				var columnDefinition = $scope.$parent.$parent.col;
				var curWidget = $scope.$parent.model;
				if (!$scope.slideshowView) {
					dashboardFilterInitializationService.markWidgetCreated('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
				}
				unableToFixValueParetoService.getUnableToFixValueParetoData(
					$scope.leanFilterService, $scope.ignoreFilters, $scope.pastTimePeriod.value)
					.then(function (d) {
						$scope.chartData = d.data || [];
						$scope.currency = d.currency || '$';
						$scope.empty = !$scope.chartData.length;
						var totalUnableToFixValue = 0;
						var maxUnableToFixValue = 0;
						angular.forEach($scope.chartData, function (entry) {
							totalUnableToFixValue += entry.unableToFixValue ? Number(entry.unableToFixValue) : 0;
							maxUnableToFixValue = Math.max(maxUnableToFixValue, Number(entry.unableToFixValue) || 0);
						});
						angular.forEach($scope.chartData, function (entry) {
							entry.barPercent = maxUnableToFixValue > 0 ? ((Number(entry.unableToFixValue) || 0) / maxUnableToFixValue) * 100 : 0;
							entry.displayName = entry.unableToFixCategoryName || $translate.instant('No reason provided');
							entry.displayValue = currencyFormatService.get(Number(entry.unableToFixValue) || 0, $scope.currency);
						});
						$scope.totalUnableToFixDisplay = currencyFormatService.get(totalUnableToFixValue, $scope.currency);
						unableToFixValueParetoService.resolveCreatedDateDrilldownRange(
							$scope.leanFilterService, $scope.pastTimePeriod.value, d)
							.then(function (createdDateDrilldownRange) {
								setDrilldown($scope.pastTimePeriod.value, createdDateDrilldownRange);
							});
					}, function () {
						$scope.chartData = [];
						$scope.empty = true;
						$scope.totalUnableToFixDisplay = '$0';
						unableToFixValueParetoService.resolveCreatedDateDrilldownRange(
							$scope.leanFilterService, $scope.pastTimePeriod.value, null)
							.then(function (createdDateDrilldownRange) {
								setDrilldown($scope.pastTimePeriod.value, createdDateDrilldownRange);
							});
					});
			} else {
				$timeout(loadData, 100);
			}
		}

		function setDrilldown(pastTimePeriod, createdDateDrilldownRange) {
			var filterQueryParams = $scope.leanFilterService.getQueryParamsObject(true, true);
			filterQueryParams.drilldown = 1;
			filterQueryParams.factory = $scope.leanFilterService.getFactoryList();
			filterQueryParams.sort = 'potentialSavings';
			filterQueryParams.sortDesc = 1;
			filterQueryParams.inventoryActionStatus = 'isUnableToFix';
			var createdDateParams = unableToFixValueParetoService.buildCreatedDateDrilldownParams(
				pastTimePeriod, createdDateDrilldownRange);
			if (createdDateParams) {
				angular.extend(filterQueryParams, createdDateParams);
			}
			$scope.$parent.$parent.widget.drillDownUrl = addQueryParam(
				'/application/f/home.html#/supply-chain/inventory-actions/', null, filterQueryParams);
		}

		loadData();
	}
})();
